import { render, staticRenderFns } from "./channel_banner.vue?vue&type=template&id=74768a3c&scoped=true"
import script from "./channel_banner.vue?vue&type=script&lang=js"
export * from "./channel_banner.vue?vue&type=script&lang=js"
import style0 from "./channel_banner.vue?vue&type=style&index=0&id=74768a3c&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "74768a3c",
  null
  
)

export default component.exports